import React from 'react';
import { PageLayout } from './PageLayout';

export const AGBPage = () => {
    return (
        <PageLayout title="Allgemeine Geschäftsbedingungen">
            <h3 className="text-xl font-semibold mt-0">§1 Geltungsbereich</h3>
            <p>
                Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung der Website DetoxTeeTest.com 
                (nachfolgend "Website"). Mit dem Zugriff auf diese Website erklären Sie sich mit diesen 
                Bedingungen einverstanden. Sollten Sie mit diesen Bedingungen nicht einverstanden sein, 
                bitten wir Sie, die Website nicht zu nutzen.
            </p>

            <h3 className="text-xl font-semibold mt-8">§2 Leistungsbeschreibung</h3>
            <p>
                DetoxTeeTest.com ist ein unabhängiges Verbraucherportal, das Produktvergleiche und 
                Informationen zu Detox-Tees bereitstellt. Wir vermitteln keine Produkte direkt, sondern 
                stellen Informationen und Links zu Drittanbietern zur Verfügung.
            </p>
            <p>
                Die auf unserer Website bereitgestellten Informationen dienen ausschließlich zu 
                Informationszwecken. Wir bemühen uns, alle Angaben aktuell und korrekt zu halten, 
                übernehmen jedoch keine Gewähr für die Vollständigkeit, Richtigkeit und Aktualität 
                der bereitgestellten Informationen.
            </p>

            <h3 className="text-xl font-semibold mt-8">§3 Haftungsausschluss</h3>
            <p>
                Die auf dieser Website bereitgestellten Informationen dienen nur zu allgemeinen 
                Informationszwecken und stellen keine medizinische Beratung dar. Die Inhalte ersetzen 
                nicht die professionelle Beratung, Diagnose oder Behandlung durch einen Arzt oder 
                eine andere medizinische Fachperson.
            </p>
            <p>
                Konsultieren Sie bei gesundheitlichen Fragen immer einen qualifizierten Arzt oder 
                eine andere medizinische Fachperson. Ignorieren Sie niemals einen professionellen 
                medizinischen Rat und zögern Sie nie, medizinischen Rat einzuholen, weil Sie etwas 
                auf dieser Website gelesen haben.
            </p>

            <h3 className="text-xl font-semibold mt-8">§4 Affiliate-Links und Vergütung</h3>
            <p>
                Diese Website enthält Affiliate-Links zu Produkten bei verschiedenen Online-Händlern. 
                Bei einem Kauf über diese Links erhalten wir eine Provision vom jeweiligen Händler.
            </p>
            <p>
                Die Provision hat keinen Einfluss auf den Kaufpreis für Sie als Kunde – es entstehen 
                Ihnen keine zusätzlichen Kosten. Die Vergütung durch Affiliate-Partnerschaften 
                beeinflusst nicht unsere redaktionelle Unabhängigkeit bei der Bewertung von Produkten.
            </p>

            <h3 className="text-xl font-semibold mt-8">§5 Geistiges Eigentum und Urheberrecht</h3>
            <p>
                Alle Inhalte dieser Website (Texte, Bilder, Grafiken, Logos, Layout) sind urheberrechtlich 
                geschützt und Eigentum von DetoxTeeTest.com, sofern nicht anders angegeben.
            </p>
            <p>
                Eine Verwendung, Vervielfältigung, Verbreitung oder öffentliche Wiedergabe der Inhalte 
                ohne ausdrückliche schriftliche Genehmigung ist nicht gestattet.
            </p>

            <h3 className="text-xl font-semibold mt-8">§6 Externe Links</h3>
            <p>
                Unsere Website enthält Links zu externen Websites Dritter. Auf die Inhalte dieser 
                externen Websites haben wir keinen Einfluss. Für die Inhalte der verlinkten Seiten 
                ist stets der jeweilige Anbieter oder Betreiber verantwortlich.
            </p>
            <p>
                Wir übernehmen keine Haftung für die Inhalte externer Links. Die Nutzung erfolgt 
                auf eigene Verantwortung.
            </p>

            <h3 className="text-xl font-semibold mt-8">§7 Nutzung der Website</h3>
            <p>
                Sie verpflichten sich, die Website nicht zu Zwecken zu nutzen, die gegen geltende 
                Gesetze verstoßen oder in irgendeiner Weise schädlich sind. Insbesondere ist es 
                untersagt:
            </p>
            <ul className="list-disc list-inside mt-4 space-y-2">
                <li>Die Website für illegale Zwecke zu nutzen</li>
                <li>Schadsoftware oder Viren zu verbreiten</li>
                <li>Die Website oder deren Infrastruktur zu beeinträchtigen</li>
                <li>Inhalte ohne Genehmigung zu kopieren oder zu verbreiten</li>
            </ul>

            <h3 className="text-xl font-semibold mt-8">§8 Änderungen der AGB</h3>
            <p>
                Wir behalten uns das Recht vor, diese AGB jederzeit und ohne vorherige Ankündigung 
                zu ändern. Die aktuell gültige Version finden Sie stets auf dieser Website. Durch 
                die weitere Nutzung der Website nach Änderungen erklären Sie sich mit den geänderten 
                Bedingungen einverstanden.
            </p>

            <h3 className="text-xl font-semibold mt-8">§9 Schlussbestimmungen</h3>
            <p>
                Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
            </p>
            <p>
                Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die 
                Wirksamkeit der übrigen Bestimmungen unberührt. Anstelle der unwirksamen Bestimmung 
                gilt eine wirksame Bestimmung als vereinbart, die dem wirtschaftlichen Zweck der 
                unwirksamen Bestimmung am nächsten kommt.
            </p>

            <p className="text-sm text-muted-foreground mt-8">
                Stand: Januar 2026
            </p>
        </PageLayout>
    );
};

